import Vue from 'vue'
import App from './App.vue'
import router from './router'
import 'bulma/css/bulma.css'
import * as VueGoogleMaps from 'vue2-google-maps'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VModal from 'vue-js-modal'

require('../public/mycss.css')

Vue.config.productionTip = false

Vue.use(VModal)
Vue.use(VueAxios, axios)
Vue.use(VueGoogleMaps, {
  load: { key: process.env.VUE_APP_GOOGLE_MAPS_KEY,
    libraries: 'places'
  }
})

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  render: h => h(App)
})




/*
 new Vue({
  render: h => h(App),
},
).$mount('#app')

*/
